import React from "react";
import { Text } from "components/Texts";
import colors from "styles/colors";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const SuggestionNumber = ({ size, bgColor, color, number }) => {
  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();
  return (
    <SuggestionsNumberZone>
      <RoundBorderBackground size={size} bgColor={bgColor} color={color}>
        {number}
      </RoundBorderBackground>
      <Text color={color} size={"7px"}>
        {t("__suggestion")}
      </Text>
    </SuggestionsNumberZone>
  );
};

export default SuggestionNumber;

const SuggestionsNumberZone = styled.div`
  margin-bottom: 4px;
`;

const RoundBorderBackground = styled.div.attrs((props) => ({
  size: props.size || 30,
  bgColor: props.bgColor || colors.positivePlus,
  color: props.color || colors.positive,
}))`
  width: ${(props) => props.size + "px"};
  height: ${(props) => props.size + "px"};
  border-radius: ${(props) => props.size / 2 + "px"};
  background-color: ${(props) => props.bgColor};
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;
